import { FIELD_TYPES } from "../../../../../domain/clinicalForms";

export const FIELD_TYPE_OPTIONS = [
  { label: "Short answer", value: FIELD_TYPES.TEXT },
  { label: "Long answer (remarks)", value: FIELD_TYPES.TEXTAREA },
  { label: "Number", value: FIELD_TYPES.NUMBER },
  { label: "Date", value: FIELD_TYPES.DATE },
  { label: "Date & Time", value: FIELD_TYPES.DATETIME },
  { label: "Dropdown (single)", value: FIELD_TYPES.SELECT },
  { label: "Dropdown (multi)", value: FIELD_TYPES.MULTISELECT },
  { label: "Checkbox", value: FIELD_TYPES.CHECKBOX },
  { label: "Radio", value: FIELD_TYPES.RADIO },
  { label: "Slider", value: FIELD_TYPES.SLIDER },
  { label: "Table", value: FIELD_TYPES.TABLE },
  { label: "File upload", value: FIELD_TYPES.FILE },
];
